import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import HomePage from './components/HomePage';
import FamilyForm from './components/FamilyForm';
import ViewFamily from './components/ViewFamily';

function App() {
  const [isLoggedIn, setIsLoggedIn] = React.useState(!!localStorage.getItem('authToken'));

  const handleLogin = (token) => {
    localStorage.setItem('authToken', token);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsLoggedIn(false);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={!isLoggedIn ? <LandingPage onLogin={handleLogin} /> : <Navigate to="/" />} />
          <Route path="/add-family" element={isLoggedIn ? <FamilyForm /> : <Navigate to="/login" />} />
          <Route path="/edit-family" element={isLoggedIn ? <FamilyForm /> : <Navigate to="/login" />} />
          <Route path="/view-family" element={isLoggedIn ? <ViewFamily /> : <Navigate to="/login" />} />
          <Route path="/" element={isLoggedIn ? <HomePage onLogout={handleLogout} /> : <Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
